import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imagePipe'
})
export class ImagePipePipe implements PipeTransform {

  transform(value: string): any {
    if (value)
      return value + '?r=' + Math.round(Math.random() * 999999);
  }

}
